//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponTip from '@/components/cardCoupons/component/couponTip'
import couponSwiper from '@/components/cardCoupons/component/couponSwiper'
import couponDownload from '@/components/cardCoupons/component/couponDownload'
import wxConfig from '@/assets/js/wx_config'
import couponVideo from '@/components/cardCoupons/component/couponVideo'
// import {Base64} from 'js-base64'

export default {
  name: "download_in",
  components:{
    couponTip,
    couponSwiper,
    couponDownload,
    couponVideo
  },
  data(){
    return{
      tipImg:require("../../assets/images/icont12@2x.png"),
      downloadFlag:false,
      swiperFlag:false,
      banners:[],
      details:[],
      posterImg:require("../../assets/images/image2we@2x.png"),
      downloadBtnImg:require("../../assets/images/icon89q@2x.png"),
      downImg:require("../../assets/images/iamge00yu@2x.jpg")
    }
  },
  mounted() {
    this.$store.commit('UPDATE_HEAD',false);
    this.$store.commit('UPDATE_FOOTER',false);
    this.$store.commit('UPDATE_PAGE_TITLE','棉花IN');
    document.title = '棉花IN'
    let scanCode = this.GetQueryString('code');
    let scanToken = this.GetQueryString('scanToken');
    console.log('--------------------------------', scanCode, scanToken);
    if (scanCode && scanCode.length) {
      window.location.href = 'https://h5.mianhuain.com/#/home?coupon=' + scanCode + '&scanToken=' + scanToken;
      return;
    }
    // try {
    //   let param = JSON.parse(Base64.decode(scanCode));
    //   if (param.code && param.code.length) {
    //     return;
    //   }
    // } catch (e) {
    //   console.error('参数解析失败，不进行任何操作');
    // }
    // this.getDownload()
    this.initShared()
  },
  methods:{
    GetQueryString(name) {
      let reg = new RegExp('(&)' + name + '=([^&]*)(&|$)', 'i')
      let r = window.location.href.replace("?", "&").substr(1).match(reg) // search,查询？后面的参数，并匹配正则
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    initShared(){
      if(wxConfig.isWeiXin()){
        let title = "棉花IN下载链接"
        let desc = "快来点击下载棉花IN，记录美好生活吧~"
        let linkUrl = "https://mobile.mianhuain.com/#/download_in"
        let imgUrl = "https://matl.oss-cn-beijing.aliyuncs.com/image/logo.jpg"
        wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl);
      }
    },
    getDownload(){
      let self = this;
      this.baseAjax({
          url:'/h5/page/resources',
          showLoading:true,
          type:'post',
          data:{
              "page":"coupon_share_h5"
          },
          success:function (data) {
              self.banners = data.banners
              self.details = data.details
              self.swiperFlag = true
          }
      })
    },
    checkIsAppleDevice(){
        let u = navigator.userAgent, app = navigator.appVersion;
        let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let iPad = u.indexOf('iPad') > -1;
        let iPhone = u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1;
        if (ios || iPad || iPhone) {
            return true;
        } else {
            return false;
        }
    },
    download(){
      // if (this.checkIsAppleDevice()) {
      //   window.location.href = "https://apps.apple.com/cn/app/%E6%A3%89%E8%8A%B1in/id1533577677";
      // }else{
      //   if(wxConfig.isWeiXin()){
      //     this.downloadFlag = true
      //   }else{
      //     window.location.href = "http://cdn.matl.binstar.vip/appVersion/mhi.apk?t=" + new Date().getTime();
      //   }
      // }
      this.$router.push(`/homePortal/invite_in`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/download/download.vue